import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-how-it-works',
    standalone: true,
    styleUrls: ['./how-it-works.page.scss'],
    templateUrl: './how-it-works.page.html'
})
export class HowItWorksPage implements OnInit {
  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('How it Works in the Future of Work');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'What is the Future of Work marketplace for the "no-exploit" freelancer gig economy, permanent & contract recruitment job site and job board platform, volunteering & business advertisements' }
    )
  }
}
